import React, { Component } from 'react';
import fire from '../fire';
import _ from 'lodash';
import { Grid, Form, Header, Dropdown } from 'semantic-ui-react';

class AddTafsir extends Component {
  constructor(props) {
    super(props);
    this.state = {
      surahNumber: "",
      surahName: "",
      surahArticles:[],
      surahs: [],
      activeSurahNumber: undefined,
      activeSurah: undefined,
      activeSurahId: undefined,
      surahTafsirs: [],
      newTafsirNumber: "",
      newTafsirTitle: "",
      newTafsirId: "",
      newYoutubeId: "",
      newSoundCloudId: ""
    };
  }

  componentDidMount() {
  
    const surahsRef = fire.database().ref('tafsirs');

    surahsRef.once('value', snapshot => {
      let surahs = snapshot.val();
      let newState = [];

      for (let item in surahs) {
        newState.push({
          id: item,
          surahNumber: surahs[item].surahNumber,
          surahName: surahs[item].surahName,
          surahArticles: surahs[item].surahArticles
        });
      }

      newState.sort(function(a, b){return a.surahNumber-b.surahNumber});

      this.setState({
        surahs: newState
      });
    });
  }

  selectSurah = (id, number, name, articles) => {
    this.setState({
        activeSurahNumber: number,
        activeSurah: name,
        activeSurahId: id,
        surahTafsirs: articles
    })
  }

  updateTafsir = () => {
    const tafsirsRef = fire.database().ref('tafsirs/' + this.state.activeSurahId);
    
    const item = {
      tafsirId: this.state.newTafsirId,
      tafsirNumber: this.state.newTafsirNumber,
      tafsirTitle: this.state.newTafsirTitle,
      youtubeId: this.state.newYoutubeId,
      soundCloudId:this.state.newSoundCloudId     
    }

    let surahTafsirs = [...this.state.surahTafsirs, item];
    tafsirsRef.set({
      'surahName':this.state.activeSurah,
      'surahNumber':this.state.activeSurahNumber,
      'surahArticles': surahTafsirs
    });

    this.setState({ 
      newTafsirId: "",
      newTafsirNumber: "",
      newTafsirTitle: "",
      newYoutubeId: "",
      newSoundCloudId: ""
    })

  }
  

  postTafsir = () => {
    const tafsirsRef = fire.database().ref('tafsirs');

    const item = {
      surahNumber: this.state.surahNumber,
      surahName: this.state.surahName,
      surahArticles:this.state.surahArticles
    }

    tafsirsRef.push(item);

    this.setState({
      surahNumber: "",
      surahName: "",
      surahArticles:[],
      numOfSurahArticles: 0
    });
  }

  handleChange = (e, { name, value }) => {
    this.setState({ 
      [name]: value
    })
  }

  handleChangeArray = (e, { name, value, index }) => {
    let surahArticles = [...this.state.surahArticles];
  
    let surahArticle = {
      ...surahArticles[index],
      [name]: value
    }
    
    surahArticles[index] = surahArticle;
    this.setState({ surahArticles }); 
  }


  render() {
    return (
      <Grid columns={1}>
        <Grid.Column>
          <Header>Add to New Surah</Header>
        </Grid.Column>
        <Grid.Column>
          <Form onSubmit={this.postTafsir}>
            <Form.Group widths='equal'>
              <Form.Input name="surahNumber" type="number" value={this.state.surahNumber} placeholder='Enter the Surah Number' onChange={this.handleChange}/>
              <Form.Input name="surahName" type="text" value={this.state.surahName} placeholder='Enter the Surah Name' onChange={this.handleChange}/>
            </Form.Group>
            <Form.Input fluid name="numOfSurahArticles" type="number" value={this.state.numOfSurahArticles} placeholder="# of Surah Articles" onChange={this.handleChange} />
              {
                _.times(this.state.numOfSurahArticles, (index) =>
                  <Form.Group key={index}> 
                    <Form.Input index={index} name="tafsirNumber" type="text" value={this.state.surahArticles[index] !== undefined ? this.state.surahArticles[index].tafsirNumber : ''} placeholder='Enter the Article Number' onChange={this.handleChangeArray}/>
                    <Form.Input index={index} name="tafsirTitle" type="text" value={this.state.surahArticles[index] !== undefined ? this.state.surahArticles[index].tafsirTitle : ''} placeholder='Enter the Article Title' onChange={this.handleChangeArray}/>
                    <Form.Input index={index} name="tafsirId" type="text" value={this.state.surahArticles[index] !== undefined ? this.state.surahArticles[index].tafsirId : ''} placeholder='Enter the Article Link' onChange={this.handleChangeArray}/>
                    <Form.Input index={index} name="youtubeId" type="text" value={this.state.surahArticles[index] !== undefined ? this.state.surahArticles[index].youtubeId : ''} placeholder='Enter the Youtube Link' onChange={this.handleChangeArray}/>
                    <Form.Input index={index} name="soundCloudId" type="text" value={this.state.surahArticles[index] !== undefined ? this.state.surahArticles[index].soundCloudId : ''} placeholder='Enter the SoundCloud Link' onChange={this.handleChangeArray}/>
                  </Form.Group>
                )
              }
            <Form.Group> 
              <Form.Button content='Submit' />
            </Form.Group>
          </Form>
        </Grid.Column>
        <Grid.Column>
          <Header>Add to Existing Surah</Header>
        </Grid.Column>
        <Grid.Column>
            <Dropdown selection text={this.state.activeSurah === undefined ? "Select Surah" : this.state.activeSurah}>
              <Dropdown.Menu>
                  {
                      this.state.surahs.map(surah => (
                          <Dropdown.Item key={surah.id} text={`${surah.surahNumber} - ${surah.surahName}`} onClick={() => this.selectSurah(surah.id, surah.surahNumber, surah.surahName, surah.surahArticles)} />
                      ))
                  }
              </Dropdown.Menu>
            </Dropdown>
          </Grid.Column>
          <Grid.Column>
          <Form onSubmit={this.updateTafsir}>
            <Form.Group> 
              <Form.Input name="newTafsirNumber" type="text" value={this.state.newTafsirNumber} placeholder='Enter the Article Number' onChange={this.handleChange}/>
              <Form.Input name="newTafsirTitle" type="text" value={this.state.newTafsirTitle} placeholder='Enter the Article Title' onChange={this.handleChange}/>
              <Form.Input name="newTafsirId" type="text" value={this.state.newTafsirId} placeholder='Enter the Article Link' onChange={this.handleChange}/>
              <Form.Input name="newYoutubeId" type="text" value={this.state.newYoutubeId} placeholder='Enter the Youtube Link' onChange={this.handleChange}/>
              <Form.Input name="newSoundCloudId" type="text" value={this.state.newSoundCloudId} placeholder='Enter the SoundCloud Link' onChange={this.handleChange}/>
            </Form.Group> 
            <Form.Group> 
              <Form.Button content='Submit' />
            </Form.Group>
          </Form>           
          </Grid.Column>
      </Grid>
    );
  }
}
export default AddTafsir;
